import Loader from "react-loaders";
import React from "react";
import _ from "i18n";


export const LoadingSuggestion = ({
  containerProps,
  loadingsSuggestions,
  suggestionsError,
  children,
  value,
  invalidEmailMessage,
}) => {
  const showNoResult =
    !loadingsSuggestions && suggestionsError && suggestionsError.code === 404 && value;
  const showInvalidEmail = !loadingsSuggestions && value && invalidEmailMessage;

  return <div {...containerProps}>
    {loadingsSuggestions ?
      <div className="loading-suggestion">{_("Loading suggestions ...")} <Loader
        type="line-spin-fade-loader"/></div>
      : children
    }
    {showNoResult && <div className="loading-suggestion"> {_("Nothing Found")}</div>}
    {showInvalidEmail && (
      <div className="loading-suggestion loading-suggestion--error">
        {invalidEmailMessage}
      </div>
    )}
  </div>
};
